module.exports = __webpack_public_path__ + "static/media/burgerHome.ac0e1ce7.svg";